export default __webpack_public_path__ + "static/media/member-image-placeholder.c40d584e.png";